import React, { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../services/config";
import { Menu, MenuItem, Button } from "@mui/material";
import {
  rSetAppointment,
  rSetCategory,
} from "../../redux/reducers/GlobalVariables";
import { useDispatch, useSelector } from "react-redux";

//FUNCTION
const NavBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const { appointment } = useSelector((state) => state.GlobalVariables);
  const [isOpen, setIsOpen] = useState(false);
  const [category, setCategory] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const fetchActiveAllCategories = async () => {
    try {
      const res = await config.getActiveCategoryAll();
      if (res.status === 200) {
        setCategory(res.data);
      } else {
        setCategory([]);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    fetchActiveAllCategories();
  }, []);
  const dispatch = useDispatch();
  const handleNavigate = (id) => {
    dispatch(rSetCategory(id));
    navigate("/anatomy");
  };

  const handleBookClick = () => {
    dispatch(rSetAppointment(true));
    navigate("/anatomy");
  };

  return (
    <>
      <nav className="navbar navbar-expand-sm">
        <div className="container">
          <a className="navbar-brand" href="#">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo-gopt.png`}
              alt=""
              className="img-fluid"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsibleNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="collapsibleNavbar">
            <ul className="navbar-nav poppins-regular">
              <li className="nav-item">
                <Button
                  aria-controls="services-menu"
                  aria-haspopup="true"
                  className="nav-link"
                  sx={{ color: "white", textTransform: "none" }} // Adjust styling
                  onClick={() => navigate("/")}
                >
                  Home
                </Button>
              </li>
              <li className="nav-item">
                <Button
                  aria-controls="services-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  className="nav-link"
                  sx={{ color: "white", textTransform: "none" }} // Adjust styling
                >
                  Services
                </Button>
                <Menu
                  id="services-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  PaperProps={{
                    sx: {
                      borderRadius: 2,
                      minWidth: 200,
                      boxShadow: 3,
                    },
                  }}
                >
                  {category.map((category) => (
                    <MenuItem
                      key={category.categoryid}
                      onClick={() => {
                        handleClose();
                        handleNavigate(category.categoryid);
                      }}
                      sx={{ "&:hover": { backgroundColor: "#f0f0f0" } }}
                    >
                      {category.categoryname}
                    </MenuItem>
                  ))}
                </Menu>
              </li>
              <li className="nav-item">
                <Button
                  className="nav-link"
                  sx={{ color: "white", textTransform: "none" }} // Adjust styling
                >
                  Blog
                </Button>
              </li>
              <li className="nav-item">
                <Button
                  className="nav-link"
                  sx={{ color: "white", textTransform: "none" }} // Adjust styling
                >
                  About Us
                </Button>
              </li>
              <li className="nav-item">
                <Button
                  className="nav-link"
                  sx={{ color: "white", textTransform: "none" }} // Adjust styling
                >
                  Contact Us
                </Button>
              </li>
            </ul>
          </div>
          <div className="res-appointment-btn">
            <button
              className="poppins-regular"
              style={
                appointment
                  ? {
                      backgroundColor: "#F2C407",
                      color: "white",
                      border: "none",
                    }
                  : {}
              }
              onClick={handleBookClick}
            >
              Book An Appointment
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default memo(NavBar);
